<template>
  <div>
    <section class="my-20">
      <Container className="lg:flex gap-24">
        <div class="flex-none w-full lg:w-80 mb-8 text-center lg:text-left lg:mb-0">
          <SectionHeader>Presented by</SectionHeader>
        </div>
        <div class="flex-1">
          <div class="space-y-8 mb-16">
            <ContactAgent
              v-if="getAgent"
              :data="getAgent"
            />
            <ContactAgent :data="agent" v-for="agent in getMultiAgents" :key="agent.id" />
          </div>
        </div>
      </Container>
      <Container>
        <div class="border-b border-gray-200 max-w-7xl"></div>
      </Container>
    </section>
    <section data-scroll-name="map" class="mb-30">
      <Container className="lg:flex gap-16">
        <div class="flex-none w-full lg:w-[500px]">
          <div class="h-[400px] lg:h-[600px]">
            <Map />
          </div>
          <div 
            class="px-12 py-8 text-white text-xl space-y-1"
            :class="{
              'bg-primary-color': !getPrimaryColor,
              [`bg-[${getPrimaryColor}]`]: getPrimaryColor
            }"
          >
            <div>{{ addressPart1 }}</div>
            <div>{{ addressPart2 }}</div>
          </div>
        </div>
        <div class="mt-14 lg:mt-0 lg:flex-1">
          <SectionHeader>Contact</SectionHeader>
          <div class="mt-16">
            <ContactForm />
          </div>
        </div>
      </Container>
    </section>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import SectionHeader from '../../components/SectionHeader';
  import ContactAgent from './components/ContactAgent';
  import ContactForm from './components/ContactForm';
  import Container from '../../components/Container';
  import Map from '../../pages/Map';
  import addressMixin from '@/shared/mixins/address';

  export default {
    name: 'Contact',
    mixins: [
      addressMixin
    ],
    components: {
      SectionHeader,
      ContactAgent,
      ContactForm,
      Container,
      Map
    },
    computed: {
      ...mapGetters('tour', ['getAgent', 'getMultiAgents', 'getPrimaryColor'])
    }
  };
</script>
